{
  "et-EE": {
    "model": {
      "profile": {
        "id": "Kasutaja ID.",
        "userName": "Kasutajanimi",
        "email": "E-posti aadress.",
        "emailConfirmed": "E-posti kinnitatud.",
        "phoneNumber": "Telefoninumber",
        "phoneNumberConfirmed": "Telefoninumber on kinnitatud.",
        "twoFactorEnabled": "Kahefaktoriline autentimine on sisse lülitatud.",
        "lockoutEnd": "Lukustuse lõpp.",
        "lockoutEnabled": "Blokeerimine on lubatud.",
        "accessFailedCount": "Ligipääsu ebaõnnestumiste arv.",
        "firstName": "Eesnimi.",
        "lastName": "Perekonnanimi",
        "picture": "Profiilipildi pilt",
        "organisationName": "Organisatsioon",
        "name": "Nimi",
        "roles": "Rollid"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Kinnitatud"
      },
      "action": {
        "resetPassword.tooltip": "Saatke kasutajale e-posti teel parooli taastamise juhised."
      },
      "message": {
        "resetPassword.success": "Kasutajale on saadetud e-kiri, milles on juhised parooli taastamiseks."
      }
    }
  }
}